import { render, staticRenderFns } from "./SkeletonImg.vue?vue&type=template&id=002a5500&scoped=true&"
import script from "./SkeletonImg.vue?vue&type=script&lang=js&"
export * from "./SkeletonImg.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonImg.vue?vue&type=style&index=0&id=002a5500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a5500",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
